import {
  createFileRoute,
  isMatch,
  Outlet,
  useMatches,
} from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import Heading from "@/globalComponents/atoms/Heading"
import { AllNamespaces } from "@/utilities/types/local"
import { Crumb } from "@/utilities/types/local"

export const Route = createFileRoute("/_authenticated/account")({
  component: RouteComponent,
  loader: () => {
    return { crumb: { translationKey: "common:account.title" } as Crumb }
  },
})

function RouteComponent() {
  const { t } = useTranslation<typeof AllNamespaces>()

  const matches = useMatches()

  if (matches.some((match) => match.status === "pending")) return <Outlet />

  const matchesWithCrumbs = matches.filter((match) =>
    isMatch(match, "loaderData.crumb")
  )

  const crumb =
    matchesWithCrumbs[matchesWithCrumbs.length - 1].loaderData?.crumb

  const title =
    crumb && "label" in crumb
      ? crumb.label
      : crumb
        ? t(crumb.translationKey)
        : null

  return (
    <>
      {title && (
        <Heading className="center" level={3} as={1} style={{ color: "var(--neutral-11)" }}>
          {title}
        </Heading>
      )}
      <Outlet />
    </>
  )
}
